/** @format */

import React, { useState, useEffect } from "react";
import "./App.css";
import "./css/header.css";
import "./css/body.css";
import "./css/footer.css";

/* End By Javi */
import "./css/custom.css";
/*import '../src/components/Movil/movil.css'*/
import "alertifyjs/build/css/alertify.min.css";
import "alertifyjs/build/css/themes/bootstrap.min.css";
/* Begin By Javi */

import "bootstrap/dist/css/bootstrap.min.css";
import "jquery/dist/jquery.min.js";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

//PAGINAS
import Home from "./components/Home";
//FIN PAGINAS

//PROVIDER
import { DataProvider } from "./context/DataContext";
import utils from "./util";
//END PROVIDER

const { isMobile } = utils;
function App() {
  const [_isMobile] = useState(isMobile());

  const InstallPWA = () => {
    const [supportsPWA, setSupportsPWA] = useState(false);
    const [promptInstall, setPromptInstall] = useState(null);
    useEffect(() => {
      const handler = (e) => {
        e.preventDefault();
        // console.log("we are being triggered :D");
        setSupportsPWA(true);
        setPromptInstall(e);
      };
      window.addEventListener("beforeinstallprompt", handler);
      return () => window.removeEventListener("transitionend", handler);
    }, []);
    const onClick = (evt) => {
      evt.preventDefault();
      // console.log("Ingreso!!");
      if (!promptInstall) {
        return;
      }
      promptInstall.prompt();
      handleClickCerrar();
    };
    const handleClickCerrar = async () => {
      let instalar = document.getElementById("cerar");
      instalar.classList.toggle("ocultar");
    };
    if (!supportsPWA) {
      return null;
    }
    return (
      <div
        className="btnSubmit"
        id="setup_button"
        aria-label="Install app"
        title="Install app"
      >
        <div className="Active-banner card text-center" id="cerar">
          <div>
            <div className="card-body">
              <p className="card-text">
                {_isMobile
                  ? "Obtenga la App en su celular haciendo click en instalar"
                  : "Obtenga la versión escritorio haciendo click en instalar"}
              </p>
              <div className="col-12">
                <div className="row">
                  <div className="col-1" />
                  <div className="col-5">
                    <a className="btn btn-danger" onClick={handleClickCerrar}>
                      Cancelar
                    </a>
                  </div>
                  <div className="col-5">
                    <a className="btn btn-warning ml-2" onClick={onClick}>
                      Instalar
                    </a>
                  </div>
                  <div className="col-1" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  return (
    <DataProvider>
      <Home isMobile={_isMobile} />
      <InstallPWA />
    </DataProvider>
  );
}

export default App;
